<template>
	<a
		class="cta_listing__item"
		v-on:mouseover="mouseover"
		v-on:mouseleave="mouseleave"
		:href="permalink.url"
	>
		<div class="title__category">
			<h3 class="category" v-html="category + ' —'"></h3>
			<h3 v-html="title"></h3>
		</div>

		<div class="image">
			<img
				v-if="background"
				class="background__image"
				:src="background.url"
				:alt="title"
			/>
		</div>

		<transition name="slide-fade">
			<div v-if="show" class="overlay">
				<span class="overlay__plus"><img :src="plus_icon" /></span>
				<primary-button :link="permalink.url" :label="'Read More'"></primary-button>
			</div>
		</transition>
	</a>
</template>

<script>
import pinkPlus from '../../images/plus-pink.svg';
import PrimaryButton from './PrimaryButton.vue';

export default {
	data() {
		return {
			show: false,
		};
	},

	props: {
		title: {
			default: 'This is a News Listing Item',
		},
		permalink: {
			default: '',
		},
		category: {},
		background: {
			default: require('../../images/dummy_image.jpg'),
		},
		plus_icon: {
			default: pinkPlus,
		},
	},

	computed: {
		styles: function () {
			return {
				'background-image': 'url(' + this.background + ')',
			};
		},
	},

	watch: {},

	methods: {
		mouseover: function () {
			this.show = true;
		},
		mouseleave: function () {
			this.show = false;
		},
	},

	components: {
		PrimaryButton,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

[size='one'] {
	grid-column: span 1;

	@media (max-width: $md) {
		grid-column: span 10;
	}
}

[size='two'] {
	grid-column: span 1;

	@media (max-width: $md) {
		grid-column: span 10;
	}
}

[size='three'] {
	grid-column: span 1;

	@media (max-width: $md) {
		grid-column: span 10;
	}
}

.cta_listing__item {
	text-decoration: none;
	min-height: 400px;
	background: darken($signs-teal, 3);
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	position: relative;
	overflow: hidden;
	border-radius: 5px;

	@media (max-width: $md) {
		min-height: 300px;
	}

	&:hover {
		.background__image {
			transition: all 0.2s ease;
			transform: scale(1.1);
		}
	}

	@media (max-width: $md) {
		grid-column: span 10;
	}

	&:nth-child(5n + 2) {
		grid-column: span 1;

		@media (max-width: $md) {
			grid-column: span 10;
		}
	}

	> img {
		position: absolute;
		height: 100%;
		top: 0;
	}

	.image {
		img {
			width: 100%;
			height: 100%;
			z-index: 0;
			transition: all 0.2s ease;
			transform: scale(1);
			object-fit: cover;
		}
	}

	.title__category {
		position: relative;
		z-index: 20;
		width: calc(100% - 4rem);
		transition: all 0.2s ease;
		opacity: 1;
		transform: translateY(0px);
		margin: 2rem;

		h3 {
			color: white;
			font-weight: normal;
			font-size: 1.75rem;
			margin: 0 0 10px;

			&:hover {
				color: $signs-pink;
			}

			&.category {
				color: $signs-pink;
			}

			&:last-child {
				margin: 0 0 0;
			}
		}

		h4 {
			color: white;
			font-weight: bold;
			font-size: 1rem;
			margin: 0 0 10px;
		}

		a {
			text-decoration: none;
			color: white;

			&:hover {
				color: $signs-pink;
			}

			@media (max-width: $md) {
				max-width: 30px;
			}
		}

		p {
			&.read_more {
				margin: 0 0 0;
				font-weight: bold;
				color: $signs-pink;
			}
		}
	}

	.overlay {
		background: rgba($signs-teal, 0.7);
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;
		padding: 2rem;
		width: calc(100% - 4rem);
		height: calc(100% - 4rem);
		position: absolute;
		top: 0;
		z-index: 30;

		&.hovered {
			background: rgba(0, 0, 0, 0.9);
		}

		&__plus {
			color: white;
			font-size: 6rem;
			font-weight: 300;
			transition: all 0.2s ease;
			opacity: 1;
			transform: translateY(0px);
			width: 100%;
			text-align: right;

			@media (max-width: $md) {
				line-height: 25px;
			}

			img {
				max-width: 60px;

				@media (max-width: $md) {
					max-width: 30px;
				}
			}
		}

		&__excerpt {
			color: white;
			max-width: 50%;
			font-size: 0.75rem;
			text-align: center;
			margin: 1rem 0 2rem;
			line-height: 1.5rem;
		}

		&__button {
			background: $signs-pink;
			color: black;
			text-decoration: none;
			padding: 0.5rem 1rem 0.25rem;
			border-radius: 5px;
			text-transform: uppercase;
			font-size: 0.75rem;
			font-weight: bold;
		}
	}
}

.slide-fade-enter-active {
	transition: opacity 0.2s ease;
	// transition-delay: .4s;
}

.slide-fade-leave-active {
	transition: opacity 0.2s cubic-bezier(1, 0.5, 0.8, 1);
	// transition-delay: .4s;
}

.slide-fade-enter,
.slide-fade-leave-to {
	opacity: 0;

	.overlay__plus {
		transform: translateY(-50px);
		opacity: 0;
	}

	.title_category {
		transform: translateY(50px);
		opacity: 0;
	}
}
</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/CtaListingItem.vue